import React, { useEffect, useState } from "react";
import Layout from "../../common/layout";
import { useTranslation } from "react-i18next";
import { Container } from "../../common/layout/styels";
import { useDispatch, useSelector } from "react-redux";
import { DisplayInformations } from "../../../elements/list/popup";
import { addPageObject } from "../../../../store/actions/pages";
import { useNavigate } from "react-router-dom";
import Loader from "../../../elements/loader";
import CrudForm from "../../../elements/list/create";
import { getData, putData } from "../../../../backend/api";
import ListTable from "../../../elements/list/list";
const InvoiceData = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.login);
  const [attributes] = useState([
    // {
    //   type: "select",
    //   placeholder: "Issued by",
    //   name: "company",
    //   validation: "",
    //   showItem: "fullName",
    //   default: "",
    //   label: "Issued by",
    //   required: true,
    //   view: true,
    //   add: false,
    //   update: true,
    //   filter: false,
    // },
    {
      type: "select",
      placeholder: "Name of the company",
      name: "company",
      validation: "",
      showItem: "organization",
      tab: "Invoice Data",
      default: "",
      label: "Name of the company",
      required: true,
      view: true,
      add: false,
      update: false,
      apiType: "API",
      selectApi: "company/select", // Assume this is the API endpoint to fill the list
    },
    // {
    //     type: "select",
    //     placeholder: "Name of the company",
    //     name: "company",
    //     validation: "",
    //     showItem: "organization",
    //     collection: "company",
    //     default: "",
    //     label: "Name of the company",
    //     filter: false,
    //     required: false,
    //     tag: true,
    //     view: true,
    //     add: false,
    //     update: false,
    //   },
    // {
    //   type: "select",
    //   placeholder: "Type",
    //   name: "equipmentType",
    //   validation: "",
    //   showItem: "locale",
    //   default: "",
    //   label: "Type",
    //   required: true,
    //   view: true,
    //   add: true,
    //   update: true,
    //   apiType: "API",
    //   selectApi: "equipment-type/select", // Assume this is the API endpoint to fill the list
    // },
    {
      type: "text",
      placeholder: "Addition",
      name: "addition",
      validation: "",
      tab: "Invoice Data",
      showItem: "",
      default: "",
      label: "Addition",
      required: false,
      view: true,
      add: true,
      update: true,
    },
    {
        type: "text",
        placeholder: "Street no",
        name: "streetNumber",
        validation: "",
        tab: "Invoice Data",
        default: "",
        label: "Street no",
        required: false,
        view: true,
        tag: true,
        add: true,
        update: true,
      },
    {
        type: "text",
        placeholder: "Postcode",
        name: "postalCode",
        validation: "",
        tab: "Invoice Data",
        default: "",
        label: "Postcode",
        required: false,
        view: true,
        tag: true,
        add: true,
        update: true,
      },
      {
        type: "text",
        placeholder: "Town",
        name: "city",
        validation: "",
        tab: "Invoice Data",
        default: "",
        label: "Town",
        required: false,
        view: true,
        tag: true,
        add: true,
        update: true,
      },
      {
        type: "select",
        apiType: "API",
        selectApi: "user/countries",
        showItem: "locale",
        placeholder: "Country",
        name: "country",
        tab: "Invoice Data",
        validation: "",
        default: "",
        label: "Country",
        required: false,
        filter: false,
        view: true,
        tag: true,
        add: true,
        update: true,
      },
      
    {
      type: "text",
      placeholder: "Telephone Number",
      name: "mobileNumber",
      validation: "",
      tab: "Invoice Data",
      showItem: "",
      default: "",
      label: "Telephone Number",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    {
        type: "text",
        placeholder: "email",
        name: "email",
        validation: "email",
        default: "",
        tab: "Invoice Data",
        label: "email",
        minimum: 5,
        maximum: 40,
        required: true,
        view: true,
      add: true,
      update: true,
      },
    {
        type: "text",
        placeholder: "Website",
        name: "website",
        validation: "",
        tab: "Invoice Data",
        default: "",
        label: "Website",
        required: false,
        view: true,
      add: true,
      update: true,
      },
      {
        type: "number",
        placeholder: "Tax ID",
        name: "taxID",
        validation: "",
        tab: "Invoice Data",
        default: "",
        label: "Tax ID",
        minimum: 12,
        maximum: 12,
        required: false,
        view: true,
        tag: true,
        add: true,
        update: true,
      },
      {
        type: "text",
        placeholder: "companyNumber",
        name: "companyNumber",
        validation: "",
        tab: "Invoice Data",
        showItem: "",
        default: "",
        label: "companyNumber",
        required: true,
        view: true,
        add: true,
        update: true,
      }
  ]);
  const navigate = useNavigate();
  const [isEditing, setIsEditing] = useState(false);
  const [updateId, setUpdateId] = useState("");
  const [updateValues, setUpdateValues] = useState({});
  const [udpateView, setUpdateView] = useState(() => {});
  const [showLoader, setShowLoader] = useState(true);
  const [message, setMessage] = useState();
  const [refreshVal, setRefreshVal] = useState(true);
  //to update the page title
  useEffect(() => {
    document.title = `${t("Invoice Data")} - Plan Time`;
  }, [t]);

  let users = useSelector((state) =>
    state.pages[`invoiceData`]
      ? state.pages[`invoiceData`]
      : {
          data: null,
          isLoading: true,
          error: null,
        }
  )

  const [data, setData] = useState(users?.data?.data[0] ?? null)

  useEffect(() => {
    const fetchdata = async ()=>{
      setLoaderBox(true);
      let page = "invoiceData"
      try {
        dispatch({
          type: "ADD_PAGE_OBJECT_LOADING",
          key: page,
        });
        await getData({skip: 0 }, page, dispatch, navigate)
          .then((response) => {
            dispatch({
              type: "ADD_PAGE_OBJECT",
              payload: { ...response, isLoading: false },
              key: page,
            });
            setData(response?.data?.data[0] ?? null);
            setLoaderBox(false);
            setRefreshVal(false);
          })
          .catch((error) => {
            dispatch({
              type: "ADD_PAGE_OBJECT",
              payload: error,
            });
            setLoaderBox(false);
            setRefreshVal(false);
          });
      } catch (error) {
        dispatch({
          type: "ADD_PAGE_OBJECT",
          payload: error,
        });
        setLoaderBox(false);
        setRefreshVal(false);
      }
    }
    if(refreshVal)
      fetchdata()
  }, [refreshVal])

  const setLoaderBox = (status) => {
    setShowLoader(status);
  };

  
  // const [actions] = useState([{ element: "button", icon: "timings", type: "subList", id: "shift-timing", itemTitle: "title", title: "timings", attributes: timingAttributes, params: { api: `timing`, itemTitle: "title", shortName: "Timing", addPrivilege: true, delPrivilege: true, updatePrivilege: true, customClass: "medium" } }]);
  // Use the useTranslation hook from react-i18next to handle translations
  // const parkingDuration = totalDuration > 120 ? (days > 0 ? days + `d, ` : ``) + (hours > 0 ? hours + `h, ` : ``) + (minutes + t("m")) : totalDuration.toFixed(0) + ` ` + t("minutes");
  return (
    <Container className="noshadow">
      {/* {!!data && <DisplayInformations customClass="invoiceData" isEditingHandler={isEditingHandler} setLoaderBox={setLoaderBox} udpateView={udpateView} attributes={attributes} data={data} setMessage={setMessage} tabName="invoiceData"  />}
      {isEditing && <CrudForm delPrivilege={true} deleteHandler={null} setMessage={setMessage} formMode={"single"} formView={"normal"} api="invoiceData" formType={"put"} updateId={updateId} header={t("update", { label: t("invoiceData") })} formInput={attributes} formValues={updateValues} submitHandler={updateHandler} isOpenHandler={isEditingHandler} isOpen={isEditing}></CrudForm>}
      */}
      <ListTable {...props} actions={[]} formMode="double" api={`invoiceData`} itemTitle={`title`} shortName={`invoiceData`} addPrivilege={true} delPrivilege={true} updatePrivilege={true} attributes={attributes} display={true} dataVal={data} setRefreshVal={setRefreshVal} ></ListTable>
      {showLoader && <Loader></Loader>} 
    </Container>
  );
};
// exporting the page with parent container layout..
export default Layout(InvoiceData);
